import { Component, DestroyRef, computed, inject, input, NgZone, signal } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateService } from "@ngx-translate/core";
import { ResourceService } from "src/app/services/resources/resource.service";
import { WeatherService } from "src/app/services/weather/weather.service";
import { WeatherDto } from "src/app/services/weather/weather.interface";
import { ScreenSaverService } from "../screen-saver/screen-saver.service";

@Component({
  selector: "app-screen-saver-left-content",
  templateUrl: "./screen-saver-left-content.component.html",
  styleUrl: "./screen-saver-content.component.scss",
  standalone: true,
  imports: [CommonModule]
})
export class ScreenSaverLeftContentComponent {
  private readonly translateService = inject(TranslateService);
  private readonly resourceService = inject(ResourceService);
  private readonly weatherService = inject(WeatherService);
  private readonly ngZone = inject(NgZone);
  private readonly destroyRef = inject(DestroyRef);
  private readonly screenSaverService = inject(ScreenSaverService);

  readonly bellIconPath = input("assets/img/hand_with_bell.svg");
  readonly showBellIcon = input(true);

  readonly isWeatherActive = computed(
    () => this.resourceService.resource()?.settings?.weather?.isActive ?? false
  );
  readonly weather = computed(
    () => this.weatherService.weatherData() || ({} as WeatherDto)
  );
  readonly currentDay = signal("");
  readonly currentDate = signal("");
  private timeInterval: any;

  constructor() {
    this.startClock();
    this.screenSaverService.addEventGesture('.hand-bell');

    this.destroyRef.onDestroy(() => {
      clearInterval(this.timeInterval);
      this.screenSaverService.removeEventGesture('.hand-bell');
    });
  }

  private startClock() {
    this.updateTime();
    this.ngZone.runOutsideAngular(() => {
      this.timeInterval = setInterval(() => {
        this.ngZone.run(() => this.updateTime());
      }, 1000);
    });
  }

  onBellClick() {
    this.screenSaverService.dismiss();
  }

  private updateTime() {
    const now = new Date();
    const lang = this.translateService.currentLang || "en";
    const dateLang = lang === "de" ? "de" : "en-GB";

    this.currentDay.set(now.toLocaleDateString(lang, { weekday: "long" }));
    this.currentDate.set(
      now.toLocaleDateString(dateLang, { day: "numeric", month: "long" })
    );
  }
}
